/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetThreadCountsByDomainQueryVariablesGQLType = Types.Exact<{
  domain: Types.ThreadDomainGQLType;
  domainIdentifier?: Types.Maybe<Types.Scalars['String']>;
}>;


export type GetThreadCountsByDomainQueryGQLType = (
  { __typename?: 'Query' }
  & { threadCountsByDomain: (
    { __typename?: 'ThreadCounts' }
    & Pick<Types.ThreadCountsGQLType, 'total' | 'pinned' | 'resolved'>
  ) }
);


export const GetThreadCountsByDomainDocumentGQLType = gql`
    query GetThreadCountsByDomain($domain: ThreadDomain!, $domainIdentifier: String) {
  threadCountsByDomain(domain: $domain, domainIdentifier: $domainIdentifier) {
    total
    pinned
    resolved
  }
}
    `;

/**
 * __useGetThreadCountsByDomainQuery__
 *
 * To run a query within a React component, call `useGetThreadCountsByDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadCountsByDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadCountsByDomainQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      domainIdentifier: // value for 'domainIdentifier'
 *   },
 * });
 */
export function useGetThreadCountsByDomainQuery(baseOptions: Apollo.QueryHookOptions<GetThreadCountsByDomainQueryGQLType, GetThreadCountsByDomainQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadCountsByDomainQueryGQLType, GetThreadCountsByDomainQueryVariablesGQLType>(GetThreadCountsByDomainDocumentGQLType, options);
      }
export function useGetThreadCountsByDomainLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadCountsByDomainQueryGQLType, GetThreadCountsByDomainQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadCountsByDomainQueryGQLType, GetThreadCountsByDomainQueryVariablesGQLType>(GetThreadCountsByDomainDocumentGQLType, options);
        }
export type GetThreadCountsByDomainQueryHookResult = ReturnType<typeof useGetThreadCountsByDomainQuery>;
export type GetThreadCountsByDomainLazyQueryGQLTypeHookResult = ReturnType<typeof useGetThreadCountsByDomainLazyQueryGQLType>;
export type GetThreadCountsByDomainQueryResultGQLType = Apollo.QueryResult<GetThreadCountsByDomainQueryGQLType, GetThreadCountsByDomainQueryVariablesGQLType>;